// extracted by mini-css-extract-plugin
export default {"iconsWrapper":"syles_iconsWrapper__ezbY4"};